import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/sharp-solid-svg-icons/faUser';

import { DecoratedIcon } from 'ui-components/components/decorated-icon';

import styles from '../app-header.module.less';

type AccountIconProps = {
  alertCount?: number;
  className?: string;
};

export const AccountIcon = ({ alertCount, className, ...rest }: AccountIconProps) => (
  <DecoratedIcon decoration={alertCount} decorationClassName='custom-decoration-class' showDecoration {...rest}>
    <FontAwesomeIcon className={classNames(styles['menu-item-icon'], className)} icon={faUser} />
  </DecoratedIcon>
);
